/**
 * Modal edit
 */

export function modalPopup() {
	if (jQuery(".modal-popup").length === 0) {
		return;
	}

	jQuery(document).on("click", ".btn__modal-popup", function (e) {
		e.preventDefault();

		const $trigger = jQuery(this);
		const modalId = $trigger.attr("data-id");

		console.log("TTTOpening modal: " + modalId);
		console.log("Opening modal: " + modalId);

		// Show the modal
		jQuery("#" + modalId).modal("show");

		// Only apply content for the edit page modal
		if (modalId === "modalEditPage") {
			const title = $trigger.attr("data-name") || "";
			const description = $trigger.attr("data-description") || "";
			const content = $trigger.attr("data-content") || "";
			const pageId = $trigger.attr("data-pageid") || "";

			const $modal = jQuery("#" + modalId);

			$modal.find("#EditTitleInput").val(title);
			$modal.find("#EditDescriptionInput").val(description);
			$modal.find("#EditPageIdInput").val(pageId);

			// Only for test
			// const quill2 = new Quill('#textareaEdit', {
			//   theme: 'snow',
			//   modules: {
			//     toolbar: [
			//       [{ header: [2, 3, 4, 5, 6, false] }], // dropdown with defaults from theme
			//       [{ 'color': [] }], // dropdown with defaults from theme // remove formatting button
			//       ['bold', 'italic'],
			//       ['link', 'blockquote', 'image'],
			//       [{ list: 'ordered' }, { list: 'bullet' }],
			//     ],
			//   },
			// });

			// Set content in the Quill editor
			quill2.root.innerHTML = content;
		}
	});
}

export default modalPopup;
